import React from 'react';
import styled from 'styled-components/macro';
import Modal from 'react-modal';
import { mainTheme } from '../../../styles/themes/main-theme';
import { ButtonPrimary } from '../buttons/primary-button';
import { ButtonSecondary } from '../buttons/secondary-button';

const modalStyles: Modal.Styles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
    },
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 100,
    },
};

const Container = styled.div`
    padding: 24px 32px;
    min-width: 280px;
    max-width: 480px;
`;

const Title = styled.div`
    font-size: ${mainTheme.fontSizes.bigger};
    font-weight: 700;
    color: ${mainTheme.colors.grey};
    margin-bottom: 12px;
`;

const Message = styled.div`
    font-size: ${mainTheme.fontSizes.normal};
    color: ${mainTheme.colors.grey};
    margin-bottom: 24px;
    line-height: 1.5;
`;

const ButtonRow = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 12px;
`;

const CancelButton = styled(ButtonSecondary)`
    background-color: #ffffff;
    border: 2px solid #707070;
    color: ${mainTheme.colors.lightGrey};
`;

export interface ISmallScreenWarningModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onContinue: () => void;
}

export const SmallScreenWarningModal: React.FC<ISmallScreenWarningModalProps> = ({ isOpen, onCancel, onContinue }) => {
    return (
        <Modal isOpen={isOpen} onRequestClose={onCancel} style={modalStyles} contentLabel="Screen size warning">
            <Container>
                <Title>Screen size not recommended</Title>
                <Message>
                    You're using a device with a smaller screen than recommended. For the best experience, try a tablet or desktop.
                </Message>
                <ButtonRow>
                    <CancelButton label="Cancel" onClick={onCancel} />
                    <ButtonPrimary label="Continue" onClick={onContinue} />
                </ButtonRow>
            </Container>
        </Modal>
    );
};
